export default class ConfigurationSelectors {
    static getUploadInTransit = (s) => s.configurations.uploadInTransit;

    static getDownloadSpinner = (s) => s.configurations.downloadSpinner;

    static getUploadProgress = (s) =>
        Math.round(
            (100 * s.configurations.uploadProgress) /
                s.configurations.uploadTotal
        );

    static getFileUploaded = (s) => {
        s.configurations.fileUploaded;
    };

    static getUploadError = (s) => {
        s.configurations.uploadError;
    };

    static getUploadErrorResponseData = (s) => {
        s.configurations.excelUploadErrorResponse;
    };

    static getconfigurationSheetUploadInTransit = (s) =>
        s.configurations.configurationSheetUploadInTransit;

    static getconfigurationSheetUploadResponse = (s) =>
        s.configurations.configurationSheetUploadResponse;

    static getDownloadInProgress = (s) => s.configurations.downloadInProgress;

    static dragOver = (s) => s.configurations.dragOver;

    static unknownFileType = (s) => s.configurations.unknownFileType;

    static catchedErrorMessage = (s) => s.configurations.catchedErrorMessage;

    static getExcelErrorMessageDataObj = (s) =>
        s.configurations.excelUploadErrorResponse;
}



// WEBPACK FOOTER //
// ./app/selectors/configurations.js